import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { animation, hoverAnimation } from '../constants/_animation';
import * as icons from '../constants/iconPaths';
import { iconPaths as _iconPaths } from '../constants/_iconPaths';
import { functions } from '../functions/_functions';
import { withTheme } from '../core/theming';
import { PropTypesRepo } from '../functions/_propTypes';

const iconPaths = { ...icons, ..._iconPaths };
/* eslint-disable react/prop-types */

const BaseIcon = React.forwardRef((props, ref) => {
  const {
    d,
    size,
    order,
    m,
    p,
    transform,
    top,
    bottom,
    left,
    right,
    cursor,
    name,
    color,
    hoverColor,
    hoverTransform,
    viewBox,
    ...rest
  } = props;
  const IconName = iconPaths[name];
  return (
    <svg viewBox={viewBox} {...rest} ref={ref}>
      <IconName color={rest.theme.colors[color]} />
    </svg>
  );
});

/* eslint-enable react/prop-types */

const IconStyled = styled(BaseIcon)`
  ${(props) => props.d && functions.makeResponsive('display', props.d)};
  ${(props) => functions.makeResponsive('height', props.size)};
  ${(props) => functions.makeResponsive('width', props.size)};
  ${(props) => functions.makeResponsive('min-width', props.size)};
  ${(props) => functions.makeResponsive('min-height', props.size)};

  ${(props) => props.order && functions.makeResponsive('order', props.order)};

  ${(props) => props.m && functions.findDirection('margin', props.m)};
  ${(props) => props.p && functions.findDirection('padding', props.p)};
  ${(props) => props.pos && functions.makeResponsive('position', props.pos)};
  ${(props) => props.transform && functions.makeResponsive('transform', props.transform)};
  ${(props) => props.top && functions.makeResponsive('top', props.top)};
  ${(props) => props.bottom && functions.makeResponsive('bottom', props.bottom)};
  ${(props) => props.left && functions.makeResponsive('left', props.left)};
  ${(props) => props.right && functions.makeResponsive('right', props.right)};
  ${(props) => props.cursor && functions.makeResponsive('cursor', props.cursor)};
  ${(props) => props.animation && animation(props)};
  
  ${(props) => props.alignSelf && `align-self: ${props.alignSelf}`};

  :hover {
    ${(props) => props.hoverTransform && functions.makeResponsive('transform', props.hoverTransform)};
    ${(props) => props.hoverAnimation && hoverAnimation(props)};
    ${(props) =>
      props.hoverColor &&
      `
        path {
          transition: ${props.theme.transition};
          fill: ${props.theme.colors[props.hoverColor]};
        }
        circle {
          transition: ${props.theme.transition};
          fill: ${props.theme.colors[props.hoverColor]};
        }
      `}
`;

const Icon = (props) => <IconStyled {...props} />;

/* eslint-disable react/require-default-props */

Icon.propTypes = {
  d: PropTypesRepo.d,
  pos: PropTypesRepo.pos,
  top: PropTypesRepo.top,
  bottom: PropTypesRepo.bottom,
  left: PropTypesRepo.left,
  right: PropTypesRepo.right,
  cursor: PropTypesRepo.cursor,
  size: PropTypesRepo.d,
  color: PropTypes.string,
  order: PropTypesRepo.order,
  m: PropTypesRepo.m,
  p: PropTypesRepo.p,
  transform: PropTypesRepo.transform,
  hoverColor: PropTypesRepo.hoverColor,
  hoverTransform: PropTypesRepo.hoverTransform,
  viewBox: PropTypes.string,
  animation: PropTypes.string,
  alignSelf: PropTypes.string,
};

/* eslint-enable react/require-default-props */

Icon.defaultProps = {
  size: '20px',
  color: 'tabSelected',
  viewBox: '0 0 50 50',
  animation: null,
  hoverTransform: null,
};

export default withTheme(Icon);
